export default __webpack_public_path__ + "static/media/award05.48a7f520.png";